// @flow

import { type UserInputValidationError, type UserInputValidatorArgs, onlyWhenSupport, VALID } from '@tectonics/prs/validation';

import { validateBrazilianDocument } from './brazilian-document';
import { validateBrazilianPhoneNumber } from './brazilian-phone-number';
import { validateBrazilianZipcode } from './brazilian-zipcode';
import { validateBrazilianState } from './brazilian-state';
import { validateBrazilianCity } from './brazilian-city';
import { validateBrazilianAddress } from './brazilian-address';
import { validateBrazilianStreetNumber } from './brazilian-street-number';
import { getCurrentFeatures } from '@tectonics/prs/payment-spec';
import { getCurrentPaymentMethodOptionalFields, hasOptionalField } from '@tectonics/prs/incoming-payment/get-payment-type-optional-fields';

export function validator({
  spec,
  prsSupport,
  userInputName,
  userInputValue,
  userInputValues,
  incomingPayment,
}: UserInputValidatorArgs): ?UserInputValidationError {
  const currentFeatures = getCurrentFeatures(spec, userInputValues['selectedPaymentMethod']);
  const onlyWhen = onlyWhenSupport(currentFeatures, prsSupport);
  let optionalFields = incomingPayment.status === 'OP' ? getCurrentPaymentMethodOptionalFields(incomingPayment, userInputValues, spec) : [];

  switch (userInputName) {
    case 'brazilianDocument':
      if (!hasOptionalField(optionalFields, 'document')) {
        return onlyWhen('field_brazilian_document') && validateBrazilianDocument(userInputValue, userInputValues['brazilianDocumentType']);
      }
      return null;

    case 'brazilianPhoneNumber':
      if (!hasOptionalField(optionalFields, 'telephone')) {
        return onlyWhen('field_brazilian_phone_number') && validateBrazilianPhoneNumber(userInputValue);
      }
      return null;

    case 'brazilianZipcode':
      if (!hasOptionalField(optionalFields, 'zipcode')) {
        return onlyWhen('field_brazilian_zipcode') && validateBrazilianZipcode(userInputValue);
      }
      return null;

    case 'brazilianState':
      if (!hasOptionalField(optionalFields, 'state')) {
        return onlyWhen('field_brazilian_state') && validateBrazilianState(userInputValue);
      }
      return null;

    case 'brazilianCity':
      if (!hasOptionalField(optionalFields, 'city')) {
        return onlyWhen('field_brazilian_city') && validateBrazilianCity(userInputValue);
      }
      return null;

    case 'brazilianAddress':
      if (!hasOptionalField(optionalFields, 'address')) {
        return onlyWhen('field_brazilian_address') && validateBrazilianAddress(userInputValue);
      }
      return null;

    case 'brazilianStreetNumber':
      if (!hasOptionalField(optionalFields, 'street_number')) {
        return onlyWhen('field_brazilian_street_number') && validateBrazilianStreetNumber(userInputValue);
      }
      return null;

    default:
      return VALID;
  }
}
